import { useEffect, useRef } from 'react';
import { RichHtmlViewer } from '../../common';

// How long a learner must dwell on a text lesson before it auto-completes.
const DWELL_MS = 3000;

interface TextViewerProps {
  content: string;
  sx?: any;
  onDwellComplete?: () => void;
}

export default function TextViewer({ content, sx, onDwellComplete }: TextViewerProps) {
  // Store callback in ref to avoid re-running timer effect when callback changes
  const callbackRef = useRef(onDwellComplete);

  // Update ref when callback changes
  useEffect(() => {
    callbackRef.current = onDwellComplete;
  }, [onDwellComplete]);

  // Dwell timer - runs once on mount
  useEffect(() => {
    if (!callbackRef.current) return;

    const timer = setTimeout(() => {
      callbackRef.current?.();
    }, DWELL_MS);

    return () => clearTimeout(timer);
  }, []); // Empty dependency array - timer only runs once on mount

  // RichHtmlViewer renders raw HTML in a shadow DOM (sanitized for XSS).
  // Tiptap's strict schema would strip imported lessons' custom HTML/<style>;
  // raw rendering preserves both Tiptap-authored AND imported content.
  return <RichHtmlViewer content={content} sx={sx} />;
}
